// TUT-244/TUT-313/TUT-530 — a busca da rota do Agendamento: o recorte (cliente,
// "Atribuídos a mim"), a pendência que filtra o quadro e a pilha de pop-ups.
// Mora fora de `router.tsx` para o teste leitor da URL chamá-la sem montar a
// rota.
import { ehPendenciaQueFiltra, focoDaPendenciaSemColuna } from "../lib/etapas";
import { focoDaUrl, type ChaveDeFoco } from "../lib/foco";
import { ligado, texto, type AgendamentoSearch } from "./buscas";

export function validarBuscaDoAgendamento(busca: Record<string, unknown>): AgendamentoSearch {
  const { atribuido, cliente, pendencia, foco, processo, ...resto } = busca;
  // TUT-530 (revisão) — `?pendencia=pericia|protocolo` filtrava o quadro por
  // uma coluna que saiu: o link salvo abre a LISTA do mesmo contador (a
  // `?foco=` de quem já veio com uma vale mais).
  const focoFinal: ChaveDeFoco | undefined = focoDaUrl(foco)
    ? (foco as ChaveDeFoco)
    : focoDaPendenciaSemColuna(pendencia);
  return {
    ...resto,
    atribuido: ligado(atribuido),
    cliente: texto(cliente),
    pendencia: ehPendenciaQueFiltra(pendencia) ? pendencia : undefined,
    // TUT-244 — lista fechada descartada aqui, e conferida DE NOVO no ponto
    // de leitura (`focoDaUrl`): o `useSearch()` da filha chega mesclado com
    // a busca do pai, que não valida nada — a lição da TUT-204g.
    ...(focoFinal ? { foco: focoFinal } : {}),
    // A ficha sem a lista atrás dela não é um nível da pilha, é um modal
    // órfão: `?processo=` sozinho é descartado.
    ...(focoFinal ? { processo: texto(processo) } : {}),
  } as AgendamentoSearch;
}
